import { SundayOfflineDb } from './db'
import { getActiveTenantKey, getOfflineDbNameForTenant } from './tenant'

const cache = new Map<string, SundayOfflineDb>()

export const getOfflineDb = (tenantKey?: string): SundayOfflineDb => {
  const resolvedTenantKey = tenantKey ?? getActiveTenantKey()
  const dbName = getOfflineDbNameForTenant(resolvedTenantKey)

  const existing = cache.get(dbName)
  if (existing) return existing

  const db = new SundayOfflineDb(dbName)
  cache.set(dbName, db)
  return db
}

export const deleteOfflineDbForTenant = async (tenantKey?: string): Promise<void> => {
  const resolvedTenantKey = tenantKey ?? getActiveTenantKey()
  const dbName = getOfflineDbNameForTenant(resolvedTenantKey)
  const db = cache.get(dbName)

  if (db) {
    try {
      db.close()
    } catch {
      // ignore
    }
    cache.delete(dbName)
  }

  const temp = new SundayOfflineDb(dbName)
  await temp.delete()
}
